/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'replay-2': {
    width: 21,
    height: 18,
    viewBox: '0 0 21 18',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M12.96 8.292a1 1 0 0 1 1.414 0l2.043 2.043 2.043-2.043a1 1 0 1 1 1.414 1.414l-2.397 2.397a1.5 1.5 0 0 1-2.121 0L12.96 9.706a1 1 0 0 1 0-1.414Z" _fill="#4990E2"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M9.083 2.666a6.333 6.333 0 0 0 0 12.667 1 1 0 1 1 0 2 8.333 8.333 0 1 1 8.334-8.334v1.834a1 1 0 1 1-2 0V8.999a6.333 6.333 0 0 0-6.334-6.333Z" _fill="#4990E2"/>'
  }
})
